import React, { useState, useEffect } from "react";
import Styles from "../../styles.module.scss"
import SideMenu from "../../sideMenu";
import DashboardHeader from "../../dashboardHeader"
import Tab from '../../../../components/tab';
import { REACT_APP_CANDIDATE_FREELANCER } from '../../../../utils/common'
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import { makeSideBarActive } from '../../../../utils/EllowUtils';
import { PanelBar, PanelBarItem, TabStrip } from "@progress/kendo-react-layout";
import { TabStripSelectEventArguments, TabStripTab } from "@progress/kendo-react-layout";
import { viewedpageMixpanel } from "../../../../utils/mixpanel";
import TimesheetHistory from "../../../../components/tables/timesheetHistory";
import PendingTimesheet from "../../../../components/tables/timesheet";
import CheckHistory from "../../../../modals/checkHistory";
import { getDetails, getTimeSheetHistory, getPendingTimesheets , resendTimesheet ,  getHistory , DropboxApi } from "./services";
import NotificationAlert from '../../../../components/notification';
import { useLocation } from "react-router-dom";
import { EmbeddedgetAPI , postAPI } from '../../../../api/apis';
import HelloSign from "hellosign-embedded";

function MyProfile(props : any ) {
  
    const [selected, setSelected] = React.useState<number>(0)
    const [sheetHistory, setTimesheetHistory] = useState(0)
    const [pendingTimesheets, setPendingTimesheet] = useState(0)
    const [candidateId, setCandidateId] = useState<string>('')
    const [candidate_data , setCandidate_data] = useState<any>()
    const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 1)
    const loginId = localStorage.getItem('loginId') || ''
    const [historyModal, setHistoryModal] = useState<boolean>(false)
    const [checkHistoryData, setCheckHistoryData] = useState<any>()
    const [project, setProject] = useState<string>('')
    const [positionTitle, setPositionTitle] = useState<string>('')
    const [message, setMessage] = useState<string>("")
    const [notification, setNotification] = useState<boolean>(false)
    const location = useLocation();

  const { candidateJobId } = location.state || '' 
  
  useEffect(() => {
  
    viewedpageMixpanel(); 
    pendingTimesheetOfCandidate(loginId)
    //timesheetHistoryOfCandidate(loginId)
    candidateDetails(loginId)   
  },[])

  let presentMonthNumber = new Date().getMonth();
  const months = ["JANUARY","FEBRUARY","MARCH","APRIL","MAY","JUNE","JULY","AUGUST","SEPTEMBER","OCTOBER","NOVEMBER","DECEMBER"];
  let presentMonth = months[presentMonthNumber]
  let presentYear = new Date().getFullYear()
  let december = 1669852800000;

  const pendingTimesheetOfCandidate = (candidateId: string | null) => {
   
    getPendingTimesheets(candidateId, candidateJobId).then((resp: any) => {
      if(resp.status === 1){
        setPendingTimesheet(resp.data && resp.data.filter((item: any) =>parseInt(item.startDate) >= december))
        if (resp.data[0].projectName) {
          setProject(resp.data[0].projectName)
        }
        if (resp.data[0].position) {
          setPositionTitle(resp.data[0].position)  
        }
      }
    })
  };

  const timesheetHistoryOfCandidate = (candidateId: string | null) => {
    getTimeSheetHistory(candidateId, candidateJobId).then((resp: any) => {
      if(resp.status === 1){
        setTimesheetHistory(resp.data)   
        if (resp.data[0] && resp.data[0].projectName) {
          setProject(resp.data[0].projectName)
        }
        if (resp.data[0] && resp.data[0].position) {
          setPositionTitle(resp.data[0].position)  
        }
      }
    })
  };

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);    
  };

  const candidateDetails = (loginId: string) => {
    getDetails(loginId).then((response) => {
      if (response && response.status === 1) {
        setCandidate_data(response.data[0].profile_metadata)
        setCandidateId(response.data[0].candidate_id)
        timesheetHistoryOfCandidate(loginId)
        }
      })
  }

  const redirectToAvailability = () => {
    setSelected(2)
  }

  const reSendReminder = (data: any) => {
    let body = {
      "timesheetId": data.timesheetId,
      "reportingManagerEmail": data.reportingManagerEmail,
      "submittedTo": data.submittedTo
    }    
    resendTimesheet(body).then((response) => {
      if (response && response.status === 1) {
        displayNotification("Reminder is successfully sent")
      }
    })
  }

  const getHistoryDetails = (timesheetId: string) => {
    getHistory(timesheetId).then((response) => {
      if (response && response.status === 1) {
        setCheckHistoryData(response.data)
      }
    })
  }

  const getSignatureUrl = (data: any) => {
   
    let value = {
      "action": "getObject",
      "filename": data.invoiceFileName,
      "bucketName": "ellow-prod-doc-upload",
    }
    postAPI(REACT_APP_CANDIDATE_FREELANCER + '/resume-signed-url', value).then((response: any) => {
      let signedUrl = response.url    
      let body = {
        "client_id": "a86c6f59ea03bceba480b19cd2f7b370",
        "signers": [
          {
            "email_address": data.email,
            "name": data.candidateName,
            "order": 0
        }],
        "file_urls": [ signedUrl ],
        "signing_options": {
          "draw": true,
          "type": true,
          "upload": true,
          "phone": false,
          "default_type": "draw"
        },
        "test_mode": true,
        "metadata": {
          "timesheetId": data.timesheetId,
          "ENV": 'STAGE',
          "fileName": data.invoiceFileName,
          "fileType": 'INVOICE'
        }
      }  
      DropboxApi(body).then((response: any) => {   
        if(response){
          EmbeddedgetAPI(`https://api.hellosign.com/v3/embedded/sign_url/${response.signature_request.signatures[0].signature_id}`).then((resp: any) => {   
            const client = new HelloSign({
              clientId: "a86c6f59ea03bceba480b19cd2f7b370"
            })
            client.open(resp.embedded.sign_url, {
              testMode: true
            })
          })
          .catch((err: any) => {
            displayNotification('Contract agreement already signed!')
          })
        }
      }) 
    })
  }

  const showHistory = (data: any) => {
    setHistoryModal(true)
    getHistoryDetails(data.timesheetId)
  }

  const displayNotification = (data: any) => {
    setMessage(data)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 4000);
  }
   
    return (
      <section className={Styles.dashboardWrapper}>
        <SideMenu menu={menu} />
        <div className={Styles.dashboardContent}>
          <DashboardHeader redirectToAvailability={redirectToAvailability} title={`Timesheet - ${project}`} positionTitle={positionTitle} navigateTo='../addTimesheet'/>
              <div className="timeSheetTab">
                <TabStrip selected={selected} onSelect={handleSelect}>
                  <Tab title="Pending Timesheets">
                    <div className="tableStyle no-padd-top no-min-height">
                      <PendingTimesheet data={pendingTimesheets} title="currentTimesheet" candidate_data={candidate_data}/>
                    </div>
                  </Tab>
                  <Tab title="Submitted Timesheets">
                    <div className="tableStyle no-padd-top no-min-height">
                      <TimesheetHistory data={sheetHistory} title="timesheetHistory" showHistory={showHistory} sendReminder={reSendReminder} candidate_data={candidate_data} getSignatureUrl={getSignatureUrl}/>
                    </div>
                  </Tab>
                </TabStrip>
                {historyModal && <CheckHistory onClose={() => setHistoryModal(false)} data={checkHistoryData} sendReminder={''} />}
              </div>
              {notification && <NotificationAlert onClose={() => setNotification(false) } closable={true} >{message}</NotificationAlert> }
        </div>
      </section>
    );
}
export default MyProfile
